Core.PortalPickupStores = {
    Locator: {
        init: function () {

            Core.PortalPickupStores.Locator.Cache = {
                $map: $('#google-map-canvas')
            };

            var _self = this;

            _self.Map = null;
            _self.Markers = [];
            _self.InfoWindows = [];

            _self.data = window.StoreJson;

            Handlebars.registerHelper("storesGetIndex", function (arr, options) {
                return $.map(arr, function (item, index) {
                    item.$idx = index;
                    return options.fn(item);
                }).join('');
            });

            if(Core.PortalPickupStores.Locator.Cache.$map.length) {
                this.setStartingPoint();
                this.createMap();
            }

            Core.Cache.$document.on("change", '#dropdownStoreLocation', function (e) {

                e.preventDefault();
                var sIndex = this.selectedIndex;
                if (sIndex > 0) {
                    var $store = window.StoreJson[this.selectedIndex-1];
                    $content = '<h4>' + $store.Name + '</h4>'
                        + '<p>' + $store.AddressLine1 + '</p>'
                        + '<p>' + $store.Suburb + '</p>'
                        + '<p>' + $store.State + ', ' + $store.Postcode + '</p>'
                        + '<p>Phone: ' + $store.Phone + '</p>'
                        + '<p class="mt-3">Business Hours: </p> <div class="mt--3">' + $store.BusinessHours + '</div>';

                    $('.shipping-option-desc').hide();
                    $('.store-address-details').html($content);
                    $('.store-address-details').show();

                    _self.showStoreInfo(this.selectedIndex-1);
                    _self.Map.setZoom(15);
                }
                else
                {
                    $content = '&nbsp;';
                    $('.shipping-option-desc').show();
                    $('.store-address-details').html($content);
                    $('.store-address-details').hide();

                    //show default map
                    _self.setStartingPoint();
                    _self.Map.setCenter({ lat: lat, lng: longitude });
                    _self.Map.setZoom(Core.IsMobile() ? 3 : 4);
                }
               
            });
        },

        setStartingPoint: function () {
            switch (window.CurrentState) {
                case 'act':
                    if (Core.IsMobile()) {
                        zoomLevel = 6;
                    } else {
                        zoomLevel = 7;
                    }
                    lat = -35.308;
                    longitude = 149.124;
                    break;
                case 'nsw':
                    zoomLevel = 6;
                    lat = -33.253;
                    longitude = 148.921;
                    break;
                case 'vic':
                    zoomLevel = 7;
			        if ( Core.IsMobile()) {
					    lat = -37.471;
						longitude = 144.785;
					} else {
						lat = -36.390;
						longitude = 144.235;
					}
                    break;
                case 'qld':
                    zoomLevel = 6;
					if (Core.IsMobile()) {
						lat = -25.917;
						longitude = 151.702;
					} else {
						lat = -23.803;
						longitude = 145.571;
					}
                    break;
                case 'sa':
					if (Core.IsMobile()){
						zoomLevel = 5;
						lat = -30.000;
						longitude = 136.209;
					} else {
						zoomLevel = 6;
						longitude = 134.989;
						lat = -31.566;
					}
                    break;
                case 'wa':
					if ( Core.IsMobile() ) {
						zoomLevel = 5;
						lat = -31.14;
						longitude = 115.159;
					} else {
						zoomLevel = 6;
						lat = -30.422;
						longitude = 117.0266;
					}
                    break;
                case 'tas':
                    zoomLevel = 7;
                    lat = -41.965;
                    longitude = 146.628;
                    break;
                case 'nt':
                    zoomLevel = 5;
                    lat = -19.491;
                    longitude = 133.550;
                    break;
                default:
                    if (Core.IsMobile()) {
                        zoomLevel = 3;
                    } else {
                        zoomLevel = 4;
                    }
                    lat = -28.926;
                    longitude = 134.175;
                    break;
            }
        },

        createMap: function () {
            var canvas = document.getElementById("google-map-canvas");

            var options = {
                disableDefaultUI: true,
                scrollWheel: false,
                draggable: true,
                streetViewControl: false,
                zoom: zoomLevel,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                minZoom: 1,
                center: new google.maps.LatLng(lat, longitude),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            this.Map = new google.maps.Map(canvas, options);
            this.plotMarkers();
            canvas.classList.add('inited');
        },

        plotMarkers: function () {
            var _self = this;

            $.each(_self.data, function (i, store) {
                _self.Markers[i] = new google.maps.Marker({
                    position: new google.maps.LatLng(store.Latitude, store.Longitude),
                    map: _self.Map,
                    title: store.Name,
                    icon: Core.Config.StoreFinder.MarkerIconPath
                });

				var _$infoContent = Core.PortalPickupStores.Locator._storeContent(store);

                _self.InfoWindows[i] = new google.maps.InfoWindow({
                    content: _$infoContent
                });

                google.maps.event.addListener(_self.Markers[i], 'click', function () {
                    _self.showStoreInfo(i);
                    _self.Map.setZoom(15);
                });

				Core.PortalPickupStores.Locator._styleWindow(_self.InfoWindows[i]);
            });
        },
        
        showStoreInfo: function (idx) {
            for (var i = 0; i < this.InfoWindows.length; i++) {
                if (i !== idx) {
                    if (this.InfoWindows[i] !== null) {
                        this.InfoWindows[i].close();
                    }
                }
                else if (this.InfoWindows[idx] !== null) {
                    //this.InfoWindows[idx].open(this.Map, this.Markers[idx]);
                    this.Map.setCenter(this.Markers[idx].position);
                }
            }
        },

		_styleWindow: function(info){
            // *
            // START INFOWINDOW CUSTOMIZE.
            // The google.maps.event.addListener() event expects
            // the creation of the infowindow HTML structure 'domready'
            // and before the opening of the infowindow, defined styles are applied.
            // *
            google.maps.event.addListener(info, 'domready', function () {
                var $iwCloseBtn = $('.gm-style-iw').next();
                var $img = $iwCloseBtn.find('img');

                if ($img.filter('.custom').length === 0) {
                    $img.hide();
                    $iwCloseBtn
                        .css({opacity: '1', right: '15px', top: '15px', width: '35px', height: '35px'})
                        .append('<img src="/site.resource/images/infowindow_x.png" class="custom" draggable="false">');
                }
            });
		},
		// Generates popup content
		_storeContent: function(store){

			// Get the Title
			var _$infoContent = '';
			if(typeof store.Name === 'string')
				_$infoContent = '<div class="mapInfoWindow"><h2>' + store.Name + '</h2><p>';
			else if(typeof store.Title === 'string')
				_$infoContent = '<div class="mapInfoWindow"><h2>' + store.Title + '</h2><p>';

			// Body Content
            if (typeof store.AddressLine1 == 'string' && store.AddressLine1.length > 0) {
                _$infoContent = _$infoContent + store.AddressLine1 + '<br>';
            }
            if (typeof store.Suburb == 'string' && store.Suburb.length > 0) {
                _$infoContent = _$infoContent + store.Suburb + '<br>';
            }
            if (typeof store.State == 'string' && store.State.length > 0) {
                _$infoContent = _$infoContent + store.State + ', ';
            }
            if (typeof store.Postcode == 'string' && store.Postcode.length > 0) {
                _$infoContent = _$infoContent + store.Postcode;
            }
            if (typeof store.Phone == 'string' && store.Phone.length > 0) {
                _$infoContent = _$infoContent + '</p><p>Phone: ' + store.Phone;
            }
            if (typeof store.Fax == 'string' && store.Fax.length > 0) {
                _$infoContent = _$infoContent + '<br>Fax: ' + store.Fax;
            }
            if (typeof store.Email == 'string' && store.Email.length > 0) {
                _$infoContent = _$infoContent + '<br> Email: ' + store.Email;
            }
			if ( typeof store.Url === 'string' )
				_$infoContent = _$infoContent + '</p><a href="' + store.Url + '">View More</a></div>';
			return _$infoContent;
		}
    },
    Details: {
        init: function () {

            var _location = document.getElementById("location-map"),
                _latlng = new google.maps.LatLng(_location.getAttribute("data-latitude"), _location.getAttribute("data-longitude")),
                _mapOptions = {
                    zoom: Core.Config.StoreFinder.MapDetailZoomLevel,
                    center: _latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [{
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [ { visibility: "off" } ]
                    }, ]
                };

            var _map = new google.maps.Map(document.getElementById("map-canvas"), _mapOptions);


            var Marker = new google.maps.Marker({
                position: _latlng,
                clickable: true,
                map: _map,
                icon: Core.Config.StoreFinder.MarkerIconPath
            });


			var _$infoContent = Core.PortalPickupStores.Locator._storeContent(StoreJson);

            var InfoWindow = new google.maps.InfoWindow({
                content: _$infoContent
            });

            google.maps.event.addListener(Marker, 'click', function () {
                InfoWindow.open(_map, Marker);
                _map.setCenter(Marker.position);
                _self.Map.setZoom(15);
            });
			Core.PortalPickupStores.Locator._styleWindow(InfoWindow);
        }
    }
};
